/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MiningFppsRewardDetailsResponse } from './mining-fpps-reward-details-response';


export interface MiningFppsRewardDetailsResponsePagedList { 
    totalCount?: number;
    items?: Array<MiningFppsRewardDetailsResponse> | null;
}

